module.exports = __webpack_public_path__ + "img/sixpackcarrier84.ac082ebf.jpg";